<template>
    <div>
        <div class="mb-3">
            <div class="company-form-box-title">Employee Cost Settings</div>
        </div>
        <div class="d-flex">
            <div class="input-group search-input-group">
                <!-- <div class="input-group-prepend">
                    <span class="input-group-text">
                        <b-icon icon="search" class="search-icon"></b-icon>
                    </span>
                </div> -->
                <input type="text" class="form-control"
                    placeholder="Search.."
                    v-model="search"
                    @input="resetPagination()">
            </div>

            <div class="ml-auto">
                <b-button id="show-btn" @click="addNew()"><b-icon icon="plus" class="mr-1"></b-icon>Add New Cost</b-button>
            </div>

        </div>

        <div>
            <hr>
        </div>
        <table class="table dataTable">
            <thead>
            <tr class="table-head">
                <template v-for="column in columns">
                    <th v-if="column.sort" @click="sortBy(column.name)"
                        :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                        style="cursor:pointer;"><span>{{ column.label }}</span></th>
                    <th v-else><span>{{ column.label }}</span></th>
                </template>
                <th class="text-right">Actions</th>
            </tr>
            </thead>

            <tbody>
            <tr class="hover-bg table-row mx-2" v-for="item in paginatedData" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ status[item.status].text }}</td>
                <td class="text-right position-relative">
                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                       style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                       aria-expanded="false">
                        <b-icon icon="three-dots-vertical"></b-icon>
                    </a>
                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-group>
                            <b-button variant="outline-secondary" @click="editData(item.id)">
                                <b-icon icon="pencil"></b-icon>
                                Edit
                            </b-button>
                            <b-button variant="outline-danger" @click="deleteData(item.id)">
                                <b-icon icon="trash"></b-icon>
                                Delete
                            </b-button>
                        </b-button-group>
                    </div>
                </td>
            </tr>
            <tr v-if="paginatedData.length > 0">
                <td :colspan="6">
                    <div class="row py-2 no-margin">
                        <div class="col-md-12 p-0 no-margin">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled">
                                    <b-form-select v-model="temp_length" :options="length_options"
                                                   @change="setFirstPage()"></b-form-select>
                                </li>
                                <li class="page-item disabled m-2">per page. Total {{ filteredData.length }} records
                                    found.
                                </li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1"
                                              v-model="pagination.currentPage"
                                              :number-of-pages="pagination.pages" prev-text="Previous"
                                              next-text="Next" base-url="#" first-number
                                              last-number></b-pagination-nav>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-if="paginatedData.length === 0">
                <td :colspan="6">{{ blankMsg }}</td>
            </tr>
            </tbody>
        </table>

        <b-card title="Company Overhead Cost">
            <b-form @submit.stop.prevent="onSubmitOverheadCost">
                <input type="hidden" v-model="cost" name="id">

                <b-form-group id="cost-group" label="Overhead Cost" label-for="cost">
                    <b-form-input id="cost" name="cost" v-model="cost"
                                  v-validate="{  }"
                                  :state="validateState('cost')" aria-describedby="cost-feedback"
                                  data-vv-as="Overhead Cost"></b-form-input>
                    <b-form-invalid-feedback id="cost-feedback">
                        {{ veeErrors.first('cost') }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <div class="">
                    <b-button type="submit" variant="success">Save</b-button>
                </div>
            </b-form>
        </b-card>



        <b-modal id="bv-modal-cost-settings" size="sm" hide-footer title="Details">
            <b-form @submit.stop.prevent="onSubmit">
                <input type="hidden" v-model="data.id" name="id">

                <b-form-group id="name-group" label="Name" label-for="name">
                    <b-form-input id="name" name="name" v-model="data.name"
                                  v-validate="{ required: true, min: 3 , alpha_spaces: true }"
                                  :state="validateState('name')" aria-describedby="name-feedback"
                                  data-vv-as="Name"></b-form-input>
                    <b-form-invalid-feedback id="name-feedback">
                        {{ veeErrors.first('name') }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <div class="">
                    <b-button type="submit" variant="success">Submit</b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
import ctcOverlay from '../js/ctcOverlay';
export default {
    mixins: [ctcOverlay],


    mounted() {
        // this.permission = this.$acl['leave-type'];
    },
    props: [],
    watch: {
        showOverlay(newVal) {
            this.ctcOverlay(newVal);
        }
    },
    data() {
        let sortOrders = {};
        let columns = [
            {label: 'Name', name: 'name', sort: true},
            {label: 'Status', name: 'status'},
        ];
        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            blankMsg: 'Fetching data..',

            datalist: [],
            showOverlay: false,
            data: {},

            search: '',
            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 10,
            temp_length: 10,
            length_options: [
                {value: 10, text: "10"},
                {value: 20, text: "20"},
                {value: 50, text: "50"},
                {value: 100, text: "100"}
            ],
            pagination: {currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1},

            status: [
                {value: "0", text: "Disabled"},
                {value: "1", text: "Enable"},
            ],

            cost:0,
        }
    },
    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.data = {};
            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-cost-settings');
        },
        getData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get('/cost-to-company/head').then(function (response) {
                if (this.datalist.length === 0)
                {
                    currentObj.blankMsg = "Nothing found.";
                }
                currentObj.datalist = response.data;
            }.bind(this)).catch(function (error) {
                currentObj.serverError(error);
            });
        },
        editData: function (x) {
            if (!this.checkNet()) return false;
            this.showOverlay = true;
            let currentObj = this;
            axios.get('employee-cost/' + x).then(function (response) {
                currentObj.data = response.data;
                currentObj.showOverlay = false;
                currentObj.$bvModal.show('bv-modal-cost-settings');
            }.bind(this)).catch(function (error) {
                currentObj.showOverlay = false;
                currentObj.serverError(error);
            });
        },
        deleteData(id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this statement.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.delete('employee-cost/' + id).then(function (response) {
                        this.getData();
                        this.showOverlay = false;

                    }.bind(this))
                        .catch(function (error) {

                            currentObj.showOverlay = false;
                            currentObj.serverError(error);
                        });
                }
            });
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.showOverlay = true;

                e.preventDefault();
                let currentObj = this;

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.data)) {
                    formData.append(key, value);
                }

                let url = 'employee-cost';

                if (this.data.id > 0) {
                    url = url + "/" + this.data.id + '?_method=PUT';
                }

                axios.post(url, formData)
                    .then(function (response) {
                        this.getData();
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        this.showOverlay = false;
                        this.resetForm();
                        this.$bvModal.hide('bv-modal-cost-settings');
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showOverlay = false;
                        currentObj.serverError(error);
                    });
            });
        },
        onSubmitOverheadCost(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                
                e.preventDefault();
                let currentObj = this;

                let formData = new FormData();

                formData.append('overheadcost', this.cost);

                let url = '/cost-to-company/overhead';
                
                axios.post(url, formData)
                    .then(function (response) {
                        this.getData();
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showOverlay = false;
                        currentObj.serverError(error);
                    });
            });
        },

        
    },
    created: function () {
        this.getData();
    },
    computed:
        {
            filteredData() {
                let filtered_list = this.datalist;
                if (this.search) {
                    filtered_list = filtered_list.filter((row) => {
                        return Object.keys(row).some((key) => {
                            return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                        })
                    });

                    if (filtered_list.length === 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) {
                    filtered_list = filtered_list.slice().sort((a, b) => {
                            let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } else if (this.columns[index].type && this.columns[index].type === 'number') {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } else {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData() {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
        }
}
</script>
